import React, { useState, useEffect } from 'react';
import { PrivatePageLayout, PageHeader, PageCard } from '../../components/PrivatePage';
import CandleChart from './CandleChart';
import SelectSymbol from '../../components/SelectSymbol/SelectSymbol';
import { getDashboard } from '../../services/HydraService';
import InfoBlock from './InfoBlock/InfoBlock';
import Toast from '../../components/Toast/Toast';
import useWebSocket from 'react-use-websocket';

function Dashboard() {
    const [notification, setNotification] = useState({ text: '', type: '' });
    const [chartSymbol, setChartSymbol] = useState('BTCUSDT');
    const [report, setReport] = useState({});

    useEffect(() => {
        getDashboard()
            .then((result) => setReport(result))
            .catch((error) => {
                console.error(error.response ? error.response.data : error);
                setNotification({ type: 'error', text: error.response ? error.response.data : error });
            });
    }, []);

    function onChangeSymbol(event) {
        setChartSymbol(event.target.value);
    }

    const { lastJsonMessage } = useWebSocket(process.env.REACT_APP_WS_URL, {
        onOpen: () => {
            console.log('Admin connected to App WS!');
        },
        onMessage: () => {
            if (lastJsonMessage) {
                if (lastJsonMessage.book)
                    setReport((prevState) => ({ ...prevState, book: new Date().toLocaleTimeString('en-US') }));
                else if (lastJsonMessage.ticker)
                    setReport((prevState) => ({ ...prevState, ticker: new Date().toLocaleTimeString('en-US') }));
            }
        },
        queryParams: { token: localStorage.getItem('token') },
        onError: (event) => {
            console.error(event);
            setNotification({ type: 'error', text: JSON.stringify(event) });
        },
        shouldReconnect: () => true,
        reconnectInterval: 3000,
    });

    return (
        <PrivatePageLayout width="full">
            <PageHeader
                eyebrow="Admin"
                title="Dashboard"
                subtitle="Platform health, active users, and live market activity."
                actions={<SelectSymbol onChange={onChangeSymbol} symbol={chartSymbol} />}
            />

            <PageCard title="Market chart" description={`Live candles for ${chartSymbol}.`}>
                <CandleChart symbol={chartSymbol} />
            </PageCard>

            <div className="admin-info-grid">
                <InfoBlock title="Active automations" value={report.automations} precision={0} />
                <InfoBlock title="Active monitors" value={report.monitors} precision={0} />
                <InfoBlock title="Active users" value={report.users} precision={0} />
                <InfoBlock title="Active connections" value={report.connections ? report.connections.length : 0} precision={0} />
                <InfoBlock title="Ticker health" value={report.ticker} precision={0} />
                <InfoBlock title="Book health" value={report.book} precision={0} />
            </div>

            <Toast type={notification.type} text={notification.text} />
        </PrivatePageLayout>
    );
}

export default Dashboard;
